import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
var ConfirmationModalService = /** @class */ (function () {
    function ConfirmationModalService(modalService) {
        this.modalService = modalService;
    }
    ConfirmationModalService.prototype.open = function (title, bodyTranslateParams) {
        var bodyParagraphs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            bodyParagraphs[_i - 2] = arguments[_i];
        }
        var modalRef = this.modalService.open(ConfirmationModalComponent, { size: 'sm' });
        var instance = modalRef.componentInstance;
        instance.title = title;
        instance.bodyParagraphs = bodyParagraphs;
        instance.bodyTranslateParams = bodyTranslateParams;
        return modalRef.result;
    };
    ConfirmationModalService.prototype.openWithNonTranslatableContentAlsoPresent = function (title, nonTranslatableBodyParagraphs, bodyTranslateParams) {
        var bodyParagraphs = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            bodyParagraphs[_i - 3] = arguments[_i];
        }
        var modalRef = this.modalService.open(ConfirmationModalComponent, { size: 'sm' });
        var instance = modalRef.componentInstance;
        instance.title = title;
        instance.bodyParagraphs = bodyParagraphs;
        instance.bodyTranslateParams = undefined;
        instance.nonTranslatableBodyParagraphs = nonTranslatableBodyParagraphs;
        return modalRef.result;
    };
    ConfirmationModalService.prototype.openEditInProgress = function () {
        return this.open('Edit in progress', undefined, 'Are you sure that you want to continue? By continuing unsaved changes will be lost.');
    };
    ConfirmationModalService.prototype.openModalClose = function () {
        return this.open('Modals are open', undefined, 'Are you sure that you want to continue? By continuing all modals will be closed.');
    };
    return ConfirmationModalService;
}());
export { ConfirmationModalService };
var ConfirmationModalComponent = /** @class */ (function () {
    function ConfirmationModalComponent(modal) {
        this.modal = modal;
    }
    ConfirmationModalComponent.prototype.cancel = function () {
        this.modal.dismiss('cancel');
    };
    ConfirmationModalComponent.prototype.confirm = function () {
        this.modal.close();
    };
    return ConfirmationModalComponent;
}());
export { ConfirmationModalComponent };
